import { useAppContext } from '../AppContext/AppContext';
import { CurrentUserFeatureFlags } from '../graphql/generated';

export const useCurrentUserFeatureFlags = (): CurrentUserFeatureFlags => {
  const { user } = useAppContext();
  return user?.featureFlags || { allowToAccessEnergyStore: false };
};
